// extracted by mini-css-extract-plugin
module.exports = {"searchItems":"clientPending_searchItems__3pwYc","searchItem":"clientPending_searchItem__2Wbc1","searchItemText":"clientPending_searchItemText__1xrEz"};